import { useEffect } from 'react'
import './style.css'
import TopBar from '../../components/general/topbar/TopBar';
import Footer from '../../components/general/footer/Footer';
import { useNavigate } from 'react-router-dom';
import ButtonMinimalist from '../../components/general/button/ButtonMinimalist';
import ProductosBanner from '../../assets/images/banners/webps/aires1.webp'
import { Helmet } from 'react-helmet';
import LogosAires from '../../assets/images/banners/webps/logosAires.webp'

export default function Aires() {

  let navigate = useNavigate();

  useEffect(() => {
    window.scroll(0,0);
  })

  const metaTags = {
    title: "Aires acondicionados",
    description: "Aires acondicionados para tus necesidades. Modelos split y piso techo; para hogar, comercio, salón y demás. Pedi el tuyo",
    url: "https://www.nicolinirefrigeracion.com.ar/productos/aires"
  }

  return (
    <div className='Products'>

      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" content={metaTags.description} />
        
        <meta property="og:site_name" content={metaTags.title} />
        <meta property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:image" content={ProductosBanner} />
        <meta property="og:url" content={metaTags.url} />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />
        <meta name="twitter:image" content={ProductosBanner} />
      </Helmet>

      <TopBar />
      <div className='pageDisplay' id='a1'>
        <div id="div1">
          <h2 className='title'>La temperatura que deseas</h2>
          <p className='text'>{"Los aires acondicionados Frio/Calor te permiten disfrutar del confort térmico en cualquier estación del año"}</p>
          <p className='text'>{"Refrigerando en el verano y calentando durante el invierno. Permitiendote disfrutar de la temperatura perfecta para vos"}</p>
        </div>
        <div id="div2">
          
        </div>
      </div>
      <div className='pageDisplay' id='a2'>
        <div id="div1">
          <h2 className='title'>Tecnología Inverter</h2>
          <p className='text'>{"Equipamiento más eficiente y silencioso"}</p>
          <p className='text'>{"Ahorra hasta un 40% de energía en el consumo de tu aire acondicionado"}</p>
        </div>
        <div id="div2">
          
        </div>
      </div>
      <div className='pageDisplay' id='a3'>
        <div id="div1">
          <h2 className='title'>Tus marcas preferidas</h2>
          <p className='text'>{"Trabajamos con una amplia gama de marcas y modelos de acuerdo a tus necesidades"}</p>
          <p className='text'>{"Consultá por la tuya"}</p>
        </div>
        <div id="div2">
          <img src={LogosAires} alt='Logos de BGH, Midea, Surrey, Hisense y LG. Marcas de aires acondicionados con las que trabajan'/>
        </div>
      </div>
       <div className='pageDisplay' id='a4'>
        <div id="div1">
          <h2 className='title'>¿No sabés que aire llevar?</h2>
          <p className='text'>{"Nuestra calculadora de frigorías te ayuda a determinar la potencia necesaria segun la habitación"}</p>
          <p className='text'>{"Esperamos tu consulta o llamado para asesorarte en lo que necesites"}</p>
          <ButtonMinimalist text={"Calcular"} onClick={() => navigate("/calculadora-aire-acondicionado")} />
        </div>
        <div id="div2">
          <a href='https://wa.me/5493434178703?text=%C2%A1Hola!+Quisiera+consultar+por+información+sobre+aires+acondicionados' target='_blank' rel='noreferrer'><ButtonMinimalist text={"Hacé tu consulta"} /></a>
        </div>
      </div>
      <Footer />
    </div>
  )
}